import(/* webpackMode: "eager" */ "/frontend/app/layout.tsx");
